export class AIInputModel {
  iconClass: string;
  type: 'SEND' | 'VOICE_START' | 'CHAT_STOP' | 'NONE' | 'VOICE_PROGRESS';
  chatType: 'VOICE' | 'INPUT';
  isDisabled: boolean = false;
}

export const VOICE_INPUT: AIInputModel = {
  iconClass: 'fa-regular fa-microphone text-white',
  type: 'VOICE_START',
  chatType: 'VOICE',
  isDisabled: false
};

export const VOICE_PROGRESS: AIInputModel = {
  iconClass: 'fa-solid fa-circle-stop text-error text-white',
  type: 'VOICE_PROGRESS',
  chatType: 'VOICE',
  isDisabled: false
};

export const VOICE_SEND: AIInputModel = {
  iconClass: 'fa-regular fa-paper-plane-top text-white',
  type: 'SEND',
  chatType: 'VOICE',
  isDisabled: false
};

export const VOICE_SEND_INPUT: AIInputModel = {
  iconClass: 'fa-regular fa-paper-plane-top text-white',
  type: 'SEND',
  chatType: 'INPUT',
  isDisabled: false
};

export class ResponseActionModel {
  actionType: 'DOWNLOAD' | 'SAVE' | 'NONE';
  index: number;
  actionProgress: 'PROGRESS' | 'COMPLETED' | 'FAILED';
}
